(function () {
  'use strict';

  function pushEvent(eventName, detail) {
    if (!window.dataLayer) return;
    try {
      window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
    } catch (e) {}
  }

  function boot(root) {
    if (!root || root.dataset.lpShareReady === 'true') return;
    root.dataset.lpShareReady = 'true';

    var sectionId = root.getAttribute('data-section-id') || '';
    var endpoint = root.getAttribute('data-submission-endpoint') || '';
    var canSubmit = endpoint.length > 0;

    var revealItems = root.querySelectorAll('[data-lp-share-reveal]');
    if (revealItems.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if ('IntersectionObserver' in window) {
        var revealObs = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                revealObs.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
        );
        revealItems.forEach(function (el) {
          revealObs.observe(el);
        });
      } else {
        revealItems.forEach(function (el) {
          el.classList.add('is-visible');
        });
      }
    } else {
      revealItems.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    var hLine = root.querySelector('[data-lp-share-steps-line]');
    var stepsTrack = root.querySelector('.lp-share__steps-track');
    var lineTarget = stepsTrack || hLine;
    if ('IntersectionObserver' in window && lineTarget) {
      var lineObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (hLine) hLine.classList.add('is-visible');
            if (stepsTrack) stepsTrack.classList.add('is-line-visible');
          });
        },
        { threshold: 0.3 }
      );
      lineObs.observe(lineTarget);
    } else {
      if (hLine) hLine.classList.add('is-visible');
      if (stepsTrack) stepsTrack.classList.add('is-line-visible');
    }

    var lightbox = root.querySelector('[data-lp-share-lightbox]');
    var lightboxInner = root.querySelector('[data-lp-share-lightbox-inner]');
    var lightboxClose = root.querySelector('[data-lp-share-lightbox-close]');

    var storyDialog = root.querySelector('[data-lp-share-story-dialog]');
    var storyDialogMedia = root.querySelector('[data-lp-share-story-dialog-media]');
    var storyDialogTitle = root.querySelector('[data-lp-share-story-dialog-title]');
    var storyDialogBody = root.querySelector('[data-lp-share-story-dialog-body]');
    var storyDialogAuthor = root.querySelector('[data-lp-share-story-dialog-author]');
    var storyDialogClose = root.querySelector('[data-lp-share-story-dialog-close]');

    function closeStoryDialog() {
      if (!storyDialog) return;
      storyDialog.classList.remove('is-open');
      storyDialog.setAttribute('aria-hidden', 'true');
      if (storyDialogMedia) {
        storyDialogMedia.innerHTML = '';
        storyDialogMedia.className = 'lp-share__story-dialog-media';
      }
      if (!lightbox || !lightbox.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      if (lightboxInner) lightboxInner.innerHTML = '';
      if (!storyDialog || !storyDialog.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
    }

    function openLightbox(type, src, poster) {
      if (!lightbox || !lightboxInner || !src) return;
      closeStoryDialog();
      lightboxInner.innerHTML = '';
      if (type === 'video') {
        var video = document.createElement('video');
        video.src = src;
        if (poster) video.poster = poster;
        video.controls = true;
        video.preload = 'none';
        video.playsInline = true;
        lightboxInner.appendChild(video);
      } else {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        lightboxInner.appendChild(img);
      }
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function openStoryDialog(card) {
      if (!storyDialog) return;
      closeLightbox();

      var orientation = card.getAttribute('data-modal-orientation') || 'landscape';
      var mediaType = card.getAttribute('data-modal-type') || 'image';
      var mediaSrc = card.getAttribute('data-modal-src') || '';
      var poster = card.getAttribute('data-modal-poster') || '';
      var title = card.getAttribute('data-story-title') || '';
      var author = card.getAttribute('data-story-author') || '';

      if (storyDialogTitle) storyDialogTitle.textContent = '"' + title + '"';
      var storyHtml = card.querySelector('[data-lp-share-story-html]');
      if (storyDialogBody) storyDialogBody.innerHTML = storyHtml ? storyHtml.innerHTML : '';
      if (storyDialogAuthor) storyDialogAuthor.textContent = '—' + author;

      if (storyDialogMedia && mediaSrc) {
        storyDialogMedia.className =
          'lp-share__story-dialog-media lp-share__story-dialog-media--' + orientation;
        storyDialogMedia.innerHTML = '';

        if (mediaType === 'video') {
          var storyVideo = document.createElement('video');
          storyVideo.src = mediaSrc;
          if (poster) storyVideo.poster = poster;
          storyVideo.controls = true;
          storyVideo.preload = 'none';
          storyVideo.playsInline = true;
          storyDialogMedia.appendChild(storyVideo);
        } else {
          var storyImg = document.createElement('img');
          storyImg.src = mediaSrc;
          storyImg.alt = title;
          storyDialogMedia.appendChild(storyImg);
        }
      }

      storyDialog.classList.add('is-open');
      storyDialog.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    root.querySelectorAll('[data-lp-share-media-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openLightbox(
          trigger.getAttribute('data-media-type') || 'image',
          trigger.getAttribute('data-media-src') || '',
          trigger.getAttribute('data-media-poster') || ''
        );
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });

    root.querySelectorAll('[data-lp-share-story-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        openStoryDialog(card);
      });
    });

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }
    if (storyDialogClose) storyDialogClose.addEventListener('click', closeStoryDialog);
    if (storyDialog) {
      storyDialog.addEventListener('click', function (e) {
        if (e.target === storyDialog) closeStoryDialog();
      });
    }

    document.addEventListener('keydown', function onKeydown(e) {
      if (e.key !== 'Escape') return;
      if (storyDialog && storyDialog.classList.contains('is-open')) closeStoryDialog();
      else closeLightbox();
    });

    root.querySelectorAll('[data-lp-share-cta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pushEvent('share_lopkin_cta_click', {
          cta_label: btn.getAttribute('data-cta-label') || '',
          section_id: sectionId
        });
      });
    });

    var form = root.querySelector('[data-lp-share-form]');
    if (!form) return;

    var formStarted = false;
    var uploadZone = form.querySelector('[data-lp-share-upload]');
    var fileInput = form.querySelector('[data-lp-share-file-input]');
    var preview = form.querySelector('[data-lp-share-upload-preview]');
    var submitBtn = form.querySelector('[data-lp-share-submit]');
    var successEl = form.querySelector('[data-lp-share-success]');
    var errorEl = form.querySelector('[data-lp-share-error]');
    var filesStore = [];

    function markFormStart() {
      if (formStarted) return;
      formStarted = true;
      pushEvent('share_lopkin_form_start', { section_id: sectionId });
    }

    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.addEventListener('focus', markFormStart);
    });

    function renderPreviews() {
      if (!preview) return;
      preview.innerHTML = '';
      if (!filesStore.length) {
        preview.classList.remove('has-files');
        return;
      }
      preview.classList.add('has-files');
      filesStore.forEach(function (file, index) {
        var wrap = document.createElement('div');
        wrap.className = 'lp-share__upload-file';
        var url = URL.createObjectURL(file);
        if (file.type.indexOf('video/') === 0) {
          var vid = document.createElement('video');
          vid.src = url;
          vid.muted = true;
          wrap.appendChild(vid);
        } else {
          var pImg = document.createElement('img');
          pImg.src = url;
          pImg.alt = '';
          wrap.appendChild(pImg);
        }
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'lp-share__upload-remove';
        remove.setAttribute('aria-label', 'Remove file');
        remove.textContent = '×';
        remove.addEventListener('click', function () {
          filesStore.splice(index, 1);
          renderPreviews();
        });
        wrap.appendChild(remove);
        preview.appendChild(wrap);
      });
    }

    function addFiles(fileList) {
      if (!fileList || !fileList.length) return;
      Array.prototype.forEach.call(fileList, function (file) {
        filesStore.push(file);
      });
      pushEvent('share_lopkin_upload_add', {
        section_id: sectionId,
        file_count: filesStore.length
      });
      renderPreviews();
    }

    if (uploadZone && fileInput) {
      uploadZone.addEventListener('click', function () {
        fileInput.click();
      });
      uploadZone.addEventListener('dragover', function (e) {
        e.preventDefault();
        uploadZone.classList.add('is-dragover');
      });
      uploadZone.addEventListener('dragleave', function () {
        uploadZone.classList.remove('is-dragover');
      });
      uploadZone.addEventListener('drop', function (e) {
        e.preventDefault();
        uploadZone.classList.remove('is-dragover');
        markFormStart();
        addFiles(e.dataTransfer.files);
      });
      fileInput.addEventListener('change', function () {
        markFormStart();
        addFiles(fileInput.files);
        fileInput.value = '';
      });
    }

    if (submitBtn && !canSubmit) {
      submitBtn.disabled = true;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;

      if (!canSubmit) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent =
            form.getAttribute('data-submit-disabled-message') ||
            'Submission is not available yet';
        }
        pushEvent('share_lopkin_submit_error', {
          section_id: sectionId,
          reason: 'endpoint_missing'
        });
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var consent = form.querySelector('[name="consent"]');
      if (consent && !consent.checked) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent =
            form.getAttribute('data-consent-error') || 'Please confirm the required consent';
        }
        return;
      }

      var formData = new FormData(form);
      filesStore.forEach(function (file, i) {
        formData.append('files[' + i + ']', file);
      });
      formData.append('section_id', sectionId);

      if (submitBtn) submitBtn.disabled = true;

      fetch(endpoint, {
        method: 'POST',
        body: formData,
        mode: 'cors'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('submit_failed');
          pushEvent('share_lopkin_submit_success', { section_id: sectionId });
          form.reset();
          filesStore = [];
          renderPreviews();
          formStarted = false;
          if (successEl) successEl.hidden = false;
        })
        .catch(function () {
          pushEvent('share_lopkin_submit_error', {
            section_id: sectionId,
            reason: 'request_failed'
          });
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent =
              form.getAttribute('data-submit-error-message') ||
              'Something went wrong. Please try again later';
          }
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lp-share]').forEach(boot);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
